import { isMacPlatform } from './platform/detectOS';

export const MOD_GLYPH_MAC = '⌘';
export const MOD_GLYPH_OTHER = 'Ctrl';
export const SHIFT_GLYPH_MAC = '⇧';
export const SHIFT_GLYPH_OTHER = 'Shift';
export const ALT_GLYPH_MAC = '⌥';
export const ALT_GLYPH_OTHER = 'Alt';
export const ESC_KEY_GLYPH = 'Esc';
export const ENTER_KEY_GLYPH = '↵';
export const SHORTCUT_SEPARATOR = '+';

function getModifierGlyph(): string {
  return isMacPlatform() ? MOD_GLYPH_MAC : MOD_GLYPH_OTHER;
}

function getShiftGlyph(): string {
  return isMacPlatform() ? SHIFT_GLYPH_MAC : SHIFT_GLYPH_OTHER;
}

function joinGlyphs(parts: string[]): string {
  return isMacPlatform() ? parts.join('') : parts.join(SHORTCUT_SEPARATOR);
}

export function formatShortcut(key: string): string {
  return joinGlyphs([getModifierGlyph(), key]);
}

export function formatShortcutWithShift(key: string): string {
  return joinGlyphs([getModifierGlyph(), getShiftGlyph(), key]);
}

export function formatAltShortcut(key: string): string {
  return isMacPlatform()
    ? `${ALT_GLYPH_MAC}${key}`
    : `${ALT_GLYPH_OTHER}${SHORTCUT_SEPARATOR}${key}`;
}
